module.exports = __webpack_public_path__ + "img/sizeChart.c27cbcea.jpeg";